import * as activityReducer from "../reducers/activityReducer";

// eslint-disable-next-line import/prefer-default-export
export const { getActivities, getTotalActivities } = activityReducer;
